import { useStore as baseUseStore } from "vuex";
import { key } from "~/plugins/1.vuex";

export const useStore = () => {
  return baseUseStore(key);
};
